// Máscara para campos do tipo NIRE (Número de Identificação de Registro de Empresa)
angular.module("avlib").directive("avNireMask", function(){
	return {
		require: 'ngModel',
		link: function(scope, elem, attrs, ctrl){

			var formatNire = function(value){
				if (value == null || value == ""){
					ctrl.$setValidity("nire", true);
					return value;
				}
				// Removendo todos os caracteres não numéricos:
				value = value.replace(/\D/g,'');

				// Acrescentando os devidos separadores, de acordo com o tamanho atual do número:
				if (value.length > 3){
					value = value.substr(0,3) + "." + value.substr(3);

					if (value.length > 9){
						value = value.substr(0,9) + "." + value.substr(9);

						if (value.length > 12){
							value = value.substr(0,12) + "-" + value.substr(12);

							// Eliminando dígitos em excesso:
							if (value.length > 14){
								value = value.substr(0,14);
							}
						}
					}
				}
				ctrl.$setValidity("nire", value.length == 14);
				return value;
			};

			var nireParser = function(viewValue){
				var formattedNire = formatNire(viewValue);
				ctrl.$setViewValue(formattedNire);
				ctrl.$render();
				return formattedNire.replace(/\D/g,'');
			};

			var nireFormatter = function(viewValue){
				if (viewValue){
					var modelValue = (""+viewValue).replace(/\D/g,'')
					while (modelValue.length < 11) {modelValue = "0" + modelValue;}
					ctrl.$modelValue = modelValue;
					return formatNire(modelValue);
				}
			};

			ctrl.$parsers.push(nireParser);
			ctrl.$formatters.push(nireFormatter);
		}
	};
});
